import $ from 'jquery';
import tdaConfig from 'lib/util/tda.config';
import Slicker from 'components/slicker';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';

var gbscion = {

  addCanonicalLink: function () {
    var clink = 'https://www.buyatoyota.com/' + tdaConfig.site.context_url + '/scion';
    $('head').append('<link rel="canonical" href="' + clink + '" />');
  },
  analytics: function () {
    var $scope = this.$scope;

    anAddContext(
      $scope,
      blocks.sectionBlock('Goodbye Scion.')
    );
    anClicks($scope);
    anComponentView($scope);
  },
  init: function (el) {
    this.addCanonicalLink();
    this.$scope = $(el);
    this.analytics();

    var vehicles = [
      { model: 'Yaris iA', year: '2017', img: 'pathToImage', link: 'link' },
      { model: 'Toyota 86', year: '2017', img: 'pathToImage', link: 'link' },
      { model: 'Corolla', year: '2017', img: 'pathToImage', link: 'link' }
    ];

    try {
      var gbSlideShow = new Slicker({
        $slider: $('.models-slideshow .carousel-inner'),
        slickOptions: {
          mobileFirst: true,
          slide: '.gb-slideshow-item',
          slidesToShow: 1,
          dots: true,
          arrows: true,
          centerMode: true,
          centerPadding: '0px',
          autoplay: true,
          paddingBottom: '50px',
          initFunction: function() {
            $('.gb-slideshow.carousel').css('opacity', '1'); // IMPORTANT, OBSCURES SLIDES WHILE INITIALIZING.
            $('.gb-slideshow.carousel').css('visibility', 'visible'); // IMPORTANT, REVEALS ALL SLIDEWSHOW ITEMS.
          }
        }
      });
    } catch (error) {
      console.error(' GB SLIDESHOW ERROR :::', error);
    }
  }
};

export default gbscion;
